import { render, staticRenderFns } from "./ResizeObserver.vue?vue&type=template&id=dfe4f8ec&"
import script from "./ResizeObserver.js?vue&type=script&lang=js&"
export * from "./ResizeObserver.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports